import { legacyColors } from '~/legacyTheme';

export const useSxStyles = () => {
  return {
    link: {
      height: '40px',
      padding: '8px',
      marginBottom: '7px',
      width: '94px',
      fontSize: '11px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      alignItems: 'center',
      borderBottomWidth: '2px',
      borderStyle: 'solid',
      borderColor: 'transparent',

      '&:hover': {
        '& i': {
          color: legacyColors.blue,
        },
        borderColor: legacyColors.blue,
      },
    },
    icon: {
      '&.fa': {
        fontSize: '14px',
      },
    },
  };
};
